import { OnlineOrder, OrderItem, Promotion } from 'kiolyn-api';
import { isEmpty } from 'lodash';
import applyBuyStGetStPromotion from './ApplyBuyStGetStPromotion';
import applyCheapestPromotion from './ApplyCheapestPromotion';
import getAvailablePromotions from './GetAvailablePromotions';

export default function updateAppliedPromotions(
  order: OnlineOrder,
  allPromotions: Promotion[],
  deletedItem?: OrderItem
): void {
  if (isEmpty(order.items) || isEmpty(allPromotions)) {
    return;
  }

  const cloneItems = [...order.items];
  if (deletedItem !== undefined) {
    cloneItems.push(deletedItem);
  }

  let appliedPromotions: Promotion[] = [];
  for (const item of cloneItems) {
    if (
      !item.IsPromotion ||
      item.promotion_id === undefined ||
      item.promotion_name === undefined
    ) {
      continue;
    }

    const existedPromotion = appliedPromotions.find(
      prom => prom.id === item.promotion_id
    );
    if (existedPromotion === undefined) {
      const originPromotion = allPromotions.find(
        prom => prom.id === item.promotion_id
      );
      if (originPromotion !== undefined) {
        const appliedCount = originPromotion.applied_count ?? 0;
        originPromotion.applied_count = 0;
        for (let i = 1; i <= appliedCount; i++) {
          appliedPromotions.push(originPromotion);
        }
      }
    }
    item.IsPromotion = false;
    item.promotion_id = undefined;
    item.promotion_name = undefined;
  }

  const validPromotions = getAvailablePromotions(order, appliedPromotions);
  applyBuyStGetStPromotion(validPromotions, order.items);
  for (const promotion of validPromotions) {
    if (promotion.promotion_type === 'buy_st_get_cheapest_one_free') {
      applyCheapestPromotion(promotion, order.items);
    }
  }
}
